import { showCustomToast } from 'components';

export const showManufactureRequiredErrorMessage = () =>
  showCustomToast({
    type: 'error',
    message: 'You should select at least one manufacture',
  });
